import { useCallback } from 'react';
import type { ReactElement, ReactNode } from 'react';

import styled from 'styled-components';

import { SortIndicator } from '../SortIndicator';

export const StyledSortSwitcher = styled.button({
  display: 'inline-flex',
  justifyContent: 'space-between',
  font: 'inherit',
  padding: 0,
  margin: 0,
  border: 'none',
  backgroundColor: 'transparent',
  outline: 'none',
  cursor: 'pointer',
  color: 'inherit',
  whiteSpace: 'nowrap',
  width: '100%',
});

const StyledContent = styled.span({
  whiteSpace: 'normal',
});

export type SortSwitcherProps = {
  /**
   * Параметр, по которому произведена сортировка
   */
  activeParam?: string | null;
  /**
   * Текущий параметр для сортировки
   */
  param: string;
  /**
   * Сортировка по возрастанию
   */
  asc: boolean;
  /**
   * Сортировка по умолчанию по возрастанию
   */
  isDefaultSortAsc?: boolean;

  /**
   * Обработчик изменения параметра или порядка сортировки
   * @param {string} paramName - параметр сортировки
   * @param {boolean} asc - сортировка по возрастанию
   */
  setSorting: (paramName: string | null, asc: boolean) => void;

  /**
   * Заголовок
   */
  children?: ReactNode;
};

export function SortSwitcher({
  activeParam = null,
  asc,
  children = undefined,
  isDefaultSortAsc = true,
  param,
  setSorting,
}: SortSwitcherProps): ReactElement {
  const isActive = activeParam === param;
  const shouldClean = isActive && asc !== isDefaultSortAsc;
  const newAsc = isActive ? !asc : isDefaultSortAsc;

  const onClick = useCallback(() => {
    setSorting(shouldClean ? null : param, newAsc);
  }, [setSorting, shouldClean, param, newAsc]);

  return (
    <StyledSortSwitcher
      type="button"
      onClick={onClick}
    >
      <StyledContent>{children}</StyledContent>

      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <nobr />

      <SortIndicator
        isActive={isActive}
        asc={asc}
        iconUpClassName="n3__sort-switcher__icon_up"
        iconDownClassName="n3__sort-switcher__icon_down"
        iconInactiveClassName="n3__sort-switcher__icon_empty"
      />
    </StyledSortSwitcher>
  );
}
